import { HateoasResource } from '@lagoshny/ngx-hateoas-client';
import { CompanyOwned } from '../company/company-models.model';
import { StructureElement } from './structure-element.model';
import { StructureLayer } from './structure-layer.model';

@HateoasResource('structure')
export class StructureCode extends CompanyOwned {
  public rgsObjectId!: string;
  public name!: string;
  public elementen: StructureElement[] = [];
  public lagen: StructureLayer[] = [];
}
